import React, { useState } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';

function Help() {
  const { translations } = useLanguage();
  const navigate = useNavigate();

  const [faqOpen, setFaqOpen] = useState(false);
  const [tutorialOpen, setTutorialOpen] = useState(false);

  const handleHome = () => {
    navigate('/home');
  };

  const toggleFaq = () => setFaqOpen(!faqOpen);
  const toggleTutorial = () => setTutorialOpen(!tutorialOpen);

  return (
    <div className="general-page">
      <div className="sm-container">
        <div className="header">
          <button onClick={handleHome} className="back-button">&#8592;</button>
          <h1>{translations.help}</h1>
        </div>
        
        <div className="help-info">
          <div className="help-container">
            <h3 onClick={toggleFaq} className="clickable-header">
              {translations.FAQ} {faqOpen ? '▲' : '▼'}
            </h3>
            {faqOpen && (
              <div className="help-container">
                <div>
                  <p>{translations.how_to_change_personal_data}</p>
                  <p>{translations.change_personal_data_answer}</p>
                </div>
                <div>
                  <p>{translations.how_to_see_plant_state}</p>
                  <p>{translations.see_plant_state_answer}</p>
                </div>
                <div>
                  <p>{translations.how_to_change_personal_data}</p>
                  <p>{translations.change_personal_data_answer}</p>
                </div>
              </div>
            )}
          </div>

          <div className="help-container">
            <h3 onClick={toggleTutorial} className="clickable-header">
              {translations.tutorial_of_use} {tutorialOpen ? '▲' : '▼'}
            </h3>
            {tutorialOpen && (
              <div className="tutorial-buttons">
                <button onClick={() => window.open('https://www.youtube.com', '_blank')} className="general-button fastSettings-button">
                  {translations.tutorial_of_use}
                </button>
                <button onClick={() => window.open('https://www.youtube.com', '_blank')} className="general-button fastSettings-button">
                  {translations.tutorial_of_use}
                </button>
                <button onClick={() => window.open('https://www.youtube.com', '_blank')} className="general-button fastSettings-button">
                  {translations.tutorial_of_use}
                </button>
              </div>
            )}
          </div>

          <div className="help-container">
            <h3>{translations.support_info}</h3>
            <p>{translations.support_email}</p>
            <p>{translations.phone}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Help;
